import { i18n } from '@lingui/core';
import { compileMessage } from '@lingui/message-utils/compileMessage';

/**
 * We set the message compiler here because lingui excludes it in production builds.
 * However, we need it because upgrade libraries come pre-bundled with uncompiled messages.
 */
i18n.setMessagesCompiler(compileMessage);

export const activateLocale = async (locale = 'en-US') => {
  i18n.activate(locale);
};

export default i18n;
